import { ImageBackground } from 'expo-image';
import { StyleSheet, View } from 'react-native';

import { CtaButton } from '../shared/cta-button';

export function FrenchDipCard({ url }: { url: string }) {
  return (
    <ImageBackground
      alt="French Dip. Served with au jus. Made with premium roast beef"
      source={require('./french-dip-card-background-desktop.webp')}
      placeholder={{ thumbhash: 'LzkOG4aPlpZqeXeIcIYIWIk' }}
      style={styles.background}
    >
      <View style={styles.ctaContainer}>
        <CtaButton href={url} />
      </View>
    </ImageBackground>
  );
}

const styles = StyleSheet.create({
  background: {
    aspectRatio: 1920 / 757,
  },
  ctaContainer: {
    top: '70%',
    left: '8%',
    right: '54%',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
